import Functions from "./Functions";
import { selectedPolygonTypes } from "./Constants";

import pick from "lodash/pick";
const { Error } = Functions;
const { CELLSITES } = selectedPolygonTypes;

const buildCellSitePolygons = ({ locations }) => {
	try {
		let WhiteSpacePolygons = {};

		for (let [ind, obj] of locations.entries()) {
			let { data, boundary, _id } = obj;

			const { JC_APP_ACTIVE: filterData } = data;
			let polygon = {
				_id,
				id: `${CELLSITES}-${ind}`,
				coordinates: boundary.polygon,
				style: { fillColor: "#FFFFFF11", strokeColor: "#f2290f", zIndex: 50 },
				showInfo: false,
				data: {
					filterData
				}
			};
			WhiteSpacePolygons[`${CELLSITES}-${ind}`] = polygon;
		}

		return { polygons: WhiteSpacePolygons };
	} catch (e) {
		console.error(e);
		Error("Error While Building CellSites Polygons");
	}
};

const getCellSitesSlider = ({ sliderHandler, locations }) => {
	let allData = [];
	for (let location of locations) {
		let {
			data: { JC_APP_ACTIVE: stores }
		} = location;
		allData.push(stores);
	}
	const min = Math.min(...allData);
	const max = Math.max(...allData);

	return {
		min,
		max,
		sliderHandler,
		type: CELLSITES
	};
};

const CellSites = {
	all: ({ locations, filter, range, sliderHandler }) => {
		return {
			...pick(buildCellSitePolygons({ locations, range, filter }), ["polygons"]),
			...{ slider: getCellSitesSlider({ sliderHandler, locations }) }
		};
	}
};
export default CellSites;

export { buildCellSitePolygons, getCellSitesSlider };
